import RequirementsWidgetWrapper from './Components/ContextWrapper';

export default RequirementsWidgetWrapper;
